// HIV.gov Locator home page: location + services, then on to /map/.
import { SHOWN_CATEGORIES, GROUPS, categoriesFromIntent } from './categories.js';
import { parseLocation } from './place.js';
import { SiteData } from './data.js';
import { initTheme } from './hivgov-theme.js';
import { initLanguage, t, getLang, categoryLabel, groupLabel } from './i18n.js';
import { track, pageview, setCommon } from './track.js';
import { registerServiceWorker } from './install.js';
import { at, pathTo } from './site.js';
registerServiceWorker();

const $ = (id) => document.getElementById(id);
const area = document.querySelector('.search-area');
const data = new SiteData();
const selected = new Set(categoriesFromIntent(location.search)); // a partner's ?intent=prep arrives with PrEP picked
let panel = null; // null | 'location' | 'services'
let group = null; // expanded group id

initLanguage($('lang'));
if (getLang() === 'es') $('about-link').href = pathTo('about/?lang=es');
initTheme($('theme'));
setCommon({ p: 'home', lang: getLang() });
pageview('home');
$('lang').addEventListener('click', () => track({ e: 'action', a: 'lang' }));

const PLUS = '<svg class="plus" viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" aria-hidden="true"><path d="M8 2.5v11M2.5 8h11"/></svg>';
const MINUS = '<svg class="minus" viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" aria-hidden="true"><path d="M2.5 8h11"/></svg>';

function render() {
  area.classList.toggle('open', panel !== null);
  area.classList.toggle('locating', panel === 'location');
  $('services-panel').hidden = panel !== 'services';
  $('services').placeholder = selected.size ? t('servicesSelected', { n: selected.size })
    : panel === 'services' ? t('servicesPick') : t('servicesOptional');
  $('groups').innerHTML = GROUPS.map((g) =>
    `<button class="filter-btn" type="button" data-group="${g.id}" aria-expanded="${group === g.id}"><span class="icon-wrapper">${PLUS}${MINUS}</span>${groupLabel(g)}</button>`).join('');
  $('subs').hidden = !group;
  $('subs').innerHTML = group ? SHOWN_CATEGORIES.filter((c) => c.group === group).map((c) =>
    `<button class="sub-filter-item" type="button" data-key="${c.key}" aria-pressed="${selected.has(c.key)}"><img class="svc-icon" src="${at(`hivgov/icons/${c.key}.svg`)}" alt="" width="31" height="31">${categoryLabel(c, 'short')}</button>`).join('') : '';
}

function setPanel(p) { panel = p; render(); }

$('g-location').addEventListener('click', () => { setPanel('location'); $('location').focus(); });
$('location').addEventListener('focus', () => setPanel('location'));
$('g-services').addEventListener('click', () => setPanel('services'));
$('groups').addEventListener('click', (e) => {
  const b = e.target.closest('[data-group]');
  if (!b) return;
  group = group === b.dataset.group ? null : b.dataset.group;
  render();
});
$('subs').addEventListener('click', (e) => {
  const b = e.target.closest('[data-key]');
  if (!b) return;
  const k = b.dataset.key;
  selected.has(k) ? selected.delete(k) : selected.add(k);
  render();
});
// A click anywhere else closes the panel.
// (composedPath, not contains: the clicked button may have been re-rendered away.)
document.addEventListener('click', (e) => { if (panel && !e.composedPath().includes(area)) setPanel(null); });

function showError(html) {
  $('err').innerHTML = html;
  $('err').hidden = !html;
}
const FORMAT_ERROR = t('formatError');

function go(params) {
  if (selected.size) params.set('filter', [...selected].join(','));
  if (getLang() === 'es') params.set('lang', 'es');
  location.href = pathTo(`map/?${params}`);
}

$('search').addEventListener('submit', async (e) => {
  e.preventDefault();
  const text = $('location').value.trim();
  const loc = parseLocation(text);
  if (!loc) { showError(FORMAT_ERROR); return; }
  showError('');
  $('go').disabled = true;
  // Check it exists before leaving the page, so a typo is caught here.
  const pt = loc.zip ? await data.zip(loc.zip) : await data.place(loc.city, loc.state);
  $('go').disabled = false;
  if (!pt) { showError(FORMAT_ERROR); return; }
  go(new URLSearchParams({ location: text }));
});

$('nearby').addEventListener('click', () => {
  track({ e: 'action', a: 'nearby' });
  if (!navigator.geolocation) { showError(t('geoUnsupported')); return; }
  navigator.geolocation.getCurrentPosition(
    (pos) => go(new URLSearchParams({ near: `${pos.coords.latitude.toFixed(4)},${pos.coords.longitude.toFixed(4)}` })),
    () => showError(t('geoDenied')),
    { enableHighAccuracy: true, timeout: 10000, maximumAge: 300000 },
  );
});

// The embed code points at wherever this site is served from.
$('widget-code').value = `<script type="module" src="${at('widget.js')}"></script><locator-widget></locator-widget>`;
$('widget-btn').addEventListener('click', () => {
  const open = $('widget').classList.toggle('open');
  $('widget-btn').setAttribute('aria-expanded', String(open));
  // A live widget as the preview: loaded the first time the panel opens.
  if (open && !$('widget-demo').firstChild) {
    import(at('widget.js'));
    $('widget-demo').innerHTML = `<locator-widget results="2" language="${getLang()}"></locator-widget>`;
  }
});
$('copy').addEventListener('click', async () => {
  try { await navigator.clipboard.writeText($('widget-code').value); } catch { $('widget-code').select(); }
  $('copy').classList.add('copied');
  $('copy').textContent = t('copied');
  setTimeout(() => { $('copy').classList.remove('copied'); $('copy').textContent = t('copy'); }, 2000);
});

render();
